import { render, staticRenderFns } from "./nav-view-group.vue?vue&type=template&id=0a3d62b6&"
import script from "./nav-view-group.vue?vue&type=script&lang=ts&"
export * from "./nav-view-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports